import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { NotifySettingComponent } from './components';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  imports: [CommonModule, TranslateModule, FormWrapperModule],
  exports: [NotifySettingComponent],
  declarations: [NotifySettingComponent],
})
export class NotifySettingModule {}
